import styled from "styled-components";
import { EvaluationProps, RatingWrapper } from "./GroupedEvaluation";
import Rating from "@mui/material/Rating";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import useRatingLabels from "./useRatingLabels";

const HeartsEvaluation = (props: EvaluationProps) => {
    const { subTitleId, ratingProps } = useRatingLabels({
        maxValue: props.maxValue,
        isLocked: props.isLocked,
    });

    return (
        <RatingWrapper>
            <h2 id={subTitleId}>{props.subTitle}</h2>
            <StyledRatingHeart
                {...ratingProps}
                emptyIcon={<FavoriteBorderIcon fontSize="inherit" />}
                icon={<FavoriteIcon />}
                value={Number(props.answers[props.index]?.answer)}
                max={props.maxValue}
                precision={props.useDecimal ? 0.5 : 1}
                readOnly={props.isLocked}
                onChange={(e: React.SyntheticEvent, newValue: number | null) =>
                    props.onRateChange(e, newValue, props.id, props.index)
                }
            />
        </RatingWrapper>
    );
};

const StyledRatingHeart = styled(Rating)({
    "& .MuiRating-iconFilled": {
        color: "#ff6d75",
    },
    "& .MuiRating-iconHover": {
        color: "#ff3d47",
    },
});

export default HeartsEvaluation;
